const Heading2 = ({ children, color = 'text-primary', className }) => {
    return (
        <h2 className={`font-cormorant mb-4 ${color} ${className ?? ''}`}>
            {children}
        </h2>
    )
}

export default Heading2;
